// import { useEffect, useState } from "react";
// import {
//   Box,
//   Select,
//   MenuItem,
//   FormControl,
//   FormHelperText,
//   Alert,
//   Grid,
//   Stack,
//   Paper,
//   IconButton,
// } from "@mui/material";
// import { Delete } from "@mui/icons-material";
// import CommonDialog from "../../../components/CommonDialog";

// const EditLanguageModal = (props) => {
//   console.log("📢[EditLanguageModal.js:18]: props.languageOptions: ", props.languageOptions);
//   console.log("📢[EditLanguageModal.js:18]: props.employeeData?.languages: ", props.employeeData?.languages);
//   // modal states
//   const [localLangData, setLocalLangData] = useState([...props.employeeData?.languages]);
//   const [validations, setValidations] = useState({});
//   const [multipleVal, setMultipleVal] = useState({});

//   // useEffect(() => {
//   //   if (props.open.editLanguages) {
//   //     setLocalLangData([...props.employeeData.languages]);
//   //   }
//   // }, [props.open.editLanguages]);

//   // other functions
//   const handleSubmit = () => {
//     if (isFormValid()) {
//       props.setOpen({ ...props.open, editLanguages: false });
//       props.setEmployeeData((prevState) => {
//         return {
//           ...prevState,
//           languages: [...localLangData],
//         };
//       });
//     }
//   };

//   const isFormValid = () => {
//     const data = localLangData.map((lang) => lang.id);
//     if (data.length > [...new Set(data)].length) {
//       setMultipleVal({
//         status: true,
//         msg: "A language cannot be present multiple times",
//       });
//       return false;
//     }
//     return true;
//   };

//   const handleDelete = (index) => {
//     setLocalLangData((prevState) => {
//       if (prevState.length === 1) {
//         setValidations({ status: true, msg: "Atleast one language is required" });
//         return prevState;
//       }
//       return prevState.filter((_, i) => i !== index); // no mutation
//     });
//   };
//   // const handleDelete = (index) => {
//   //   setLocalLangData((prevState) => {
//   //     if (prevState.length === 1) {
//   //       setValidations({
//   //         status: true,
//   //         msg: "Atleast one language is required",
//   //       });
//   //       return [...prevState];
//   //     }
//   //     prevState.splice(index, 1);
//   //     return [...prevState];
//   //   });
//   // };

//   return (
//     <CommonDialog
//       open={props.open.editLanguages}
//       title={"Edit Languages"}
//       onSubmit={handleSubmit}
//       onClose={() => props.setOpen({ ...props.open, editLanguages: false })}
//     >
//       <Paper style={{ ...props.style, width: "100%" }} elevation={0}>
//         <Box sx={{ padding: "10px" }}>
//           <Stack spacing={1}>
//             {localLangData?.map((lang, index) => (
//               <Grid container>
//                 <Grid xs={10} sm={10} md={10} lg={10} xl={10} item>
//                   <FormControl error={validations?.status} sx={{ width: "100%" }}>
//                     <Select
//                       variant="outlined"
//                       size="small"
//                       value={lang.id}
//                       onChange={(e) => {
//                         setLocalLangData((prevState) => {
//                           const lang = props.languageOptions.filter(
//                             (lang) => lang.id === e.target.value,
//                           );
//                           prevState[index] = {
//                             ...prevState[index],
//                             ...lang[0],
//                           };
//                           return [...prevState];
//                         });
//                       }}
//                       renderValue={(selected) => {
//                         console.log("selected", selected)
//                         const selectedLang =
//                           props.languageOptions.find((opt) => opt.id == selected)?.name ||
//                           "Unknown";
//                         return selectedLang;
//                       }}
//                     >
//                       {props.activeLanguages.map((lang) => (
//                         <MenuItem value={lang.id}>{lang.name}</MenuItem>
//                       ))}
//                     </Select>
//                     {validations?.status ? (
//                       <FormHelperText>{validations?.msg}</FormHelperText>
//                     ) : null}
//                   </FormControl>
//                 </Grid>
//                 <Grid xs={1} sm={1} md={1} lg={1} xl={1} item sx={{ textAlign: "right" }}>
//                   <IconButton size="small" onClick={() => handleDelete(index)}>
//                     <Delete color="error" />
//                   </IconButton>
//                 </Grid>
//               </Grid>
//             ))}
//             {multipleVal.status ? <Alert severity="error">{multipleVal.msg || ""}</Alert> : null}
//           </Stack>
//         </Box>
//       </Paper>
//     </CommonDialog>
//   );
// };

// export default EditLanguageModal;

import { useEffect, useState } from "react";
import {
  Box,
  Select,
  MenuItem,
  FormControl,
  FormHelperText,
  Alert,
  Grid,
  Stack,
  Paper,
  IconButton,
} from "@mui/material";
import { Delete } from "@mui/icons-material";
import CommonDialog from "../../../components/CommonDialog";

/**
 * Normalise a language entry coming from either the DB or local state
 * so we always have a stable string `id` field.
 *
 * DB shape after aggregation:
 *   { name: <string>, value: <number>, id: <string|ObjectId>, _id: <ObjectId> }
 *
 * Local shape set by AddLanguageModal / formatProfileData:
 *   { name: <string>, value: <number>, id: <string> }
 */
const normaliseLanguage = (lang) => {
  const id = String(lang.id || lang._id || "");
  const name = lang.name || "";
  const value = lang.value ?? 3;
  return { id, name, value };
};

const EditLanguageModal = (props) => {
  // Normalise on first render so we always work with { id, name, value }
  const [localLangData, setLocalLangData] = useState(
    (props.employeeData?.languages || []).map(normaliseLanguage)
  );
  const [validations, setValidations] = useState({});
  const [multipleVal, setMultipleVal] = useState({});

  // Sync if the modal re-opens with fresh data
  useEffect(() => {
    if (props.open?.editLanguages) {
      setLocalLangData(
        (props.employeeData?.languages || []).map(normaliseLanguage)
      );
      setValidations({});
      setMultipleVal({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.open?.editLanguages]);

  // ── Submit ──────────────────────────────────────────────────────
  const handleSubmit = () => {
    if (!isFormValid()) return;

    props.setEmployeeData((prevState) => ({
      ...prevState,
      languages: localLangData,
    }));
    props.setOpen({ ...props.open, editLanguages: false });
  };

  const isFormValid = () => {
    if (!localLangData.length) {
      setValidations({ status: true, msg: "At least one language is required" });
      return false;
    }

    const ids = localLangData.map((lang) => String(lang.id));
    if (ids.length > new Set(ids).size) {
      setMultipleVal({
        status: true,
        msg: "A language cannot be present multiple times",
      });
      return false;
    }

    setMultipleVal({});
    return true;
  };

  // ── Delete a row ────────────────────────────────────────────────
  const handleDelete = (index) => {
    setLocalLangData((prev) => {
      if (prev.length === 1) {
        setValidations({ status: true, msg: "At least one language is required" });
        return prev;
      }
      setValidations({});
      return prev.filter((_, i) => i !== index);
    });
  };

  // ── Change the language selected in a row ───────────────────────
  const handleChange = (index, selectedId) => {
    const matched = props.languageOptions.find(
      (opt) => String(opt.id) === String(selectedId)
    );
    if (!matched) return;

    setLocalLangData((prev) => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        id: String(matched.id),
        name: matched.name,
      };
      return updated;
    });

    // Clear duplicate warning when user changes a value
    setMultipleVal({});
  };

  // ── Resolve display name safely ─────────────────────────────────
  const resolveDisplayName = (langId) => {
    if (!langId) return "Select Language";
    // Prefer the full languageOptions list (has all, incl. disabled)
    // then fall back to activeLanguages
    const sources = [
      ...(props.languageOptions || []),
      ...(props.activeLanguages || []),
    ];
    const found = sources.find((opt) => String(opt.id) === String(langId));
    return found?.name || "Unknown Language";
  };

  return (
    <CommonDialog
      open={props.open.editLanguages}
      title={"Edit Languages"}
      onSubmit={handleSubmit}
      onClose={() => {
        props.setOpen({ ...props.open, editLanguages: false });
        setValidations({});
        setMultipleVal({});
      }}
    >
      <Paper style={{ ...props.style, width: "100%" }} elevation={0}>
        <Box sx={{ padding: "10px" }}>
          <Stack spacing={1}>
            {localLangData.map((lang, index) => (
              <Grid container key={`lang-row-${index}`} alignItems="center">
                {/* Language selector */}
                <Grid xs={10} sm={10} md={10} lg={10} xl={10} item>
                  <FormControl
                    error={validations?.status}
                    sx={{ width: "100%" }}
                  >
                    <Select
                      variant="outlined"
                      size="small"
                      value={String(lang.id || "")}
                      onChange={(e) => handleChange(index, e.target.value)}
                      displayEmpty
                      renderValue={(selected) => resolveDisplayName(selected)}
                    >
                      {/* Show all active (non-disabled) languages as options */}
                      {(props.activeLanguages || []).map((opt) => (
                        <MenuItem key={String(opt.id)} value={String(opt.id)}>
                          {opt.name}
                        </MenuItem>
                      ))}
                    </Select>
                    {validations?.status && (
                      <FormHelperText>{validations?.msg}</FormHelperText>
                    )}
                  </FormControl>
                </Grid>

                {/* Delete row */}
                <Grid
                  xs={1}
                  sm={1}
                  md={1}
                  lg={1}
                  xl={1}
                  item
                  sx={{ textAlign: "right" }}
                >
                  <IconButton size="small" onClick={() => handleDelete(index)}>
                    <Delete color="error" />
                  </IconButton>
                </Grid>
              </Grid>
            ))}

            {multipleVal.status && (
              <Alert severity="error">{multipleVal.msg}</Alert>
            )}
          </Stack>
        </Box>
      </Paper>
    </CommonDialog>
  );
};

export default EditLanguageModal;